import { render } from "./ItemGeneralInfo.vue?vue&type=template&id=194e8eda&scoped=true&lang=true"
import script from "./ItemGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ItemGeneralInfo.vue?vue&type=script&lang=js"

import "./ItemGeneralInfo.vue?vue&type=style&index=0&id=194e8eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194e8eda"]])

export default __exports__